@use '../../../../../styles/scss/vcom/mixins/breakpoints';
@use '../../../../../styles/scss/vcom/mixins/rtl';
@use '../../../../../styles/scss/vcom/themes/classic/colors' as classic;
:host {
  display: block;
}

.vs-show .vs-marquee-btn {
  opacity: 1;
}

.vs-marquee-btn {
  border: 0px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  cursor: pointer;
  bottom: calc(50%);
  transform: translateY(50%);
  z-index: 2;
  opacity: 0;
  line-height: 100%;
  font-size: 25px;
  padding: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.14);
  font-family: 'visa-icon', sans-serif;
  color: #5c5c5c;

  &:hover,
  &:focus {
    opacity: 1;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.14);
  }

  &.vs-rt-btn {
    right: 7px;

    &::after {
      content: '\e71b';
      line-height: normal;
    }

    @include breakpoints.desktop-up {
      right: 20px;
    }

    @include breakpoints.desktop-plus-up {
      right: 40px;
    }
  }

  &.vs-lt-btn {
    left: 7px;

    &::after {
      content: '\e71a';
      line-height: normal;
    }

    @include breakpoints.desktop-up {
      left: 20px;
    }

    @include breakpoints.desktop-plus-up {
      left: 40px;
    }
  }

  &:focus {
    outline-offset: -5px;
    outline: dashed black 1px;
    color: #2c2c2c;
  }

  &:hover {
    color: #2c2c2c;
  }

  @include breakpoints.desktop-up {
    line-height: 100%;
    font-size: 40px;
    padding: 15px;
  }
}
